import NavDirective from './NavDirective';
import OnRepeatDone from './OnRepeatDone';

export default angular.module('edge.platform.widgets.navigation', [])
    .directive('gwPortalNav', NavDirective)
    .directive('gwOnRepeatDone', ()=> new OnRepeatDone());